import { transformMobileFriendliness } from './mobileFriendlinessTransformer';
import { transformTapTargets } from './tapTargetsTransformer';
import { transformMobileViewport } from './mobileViewportTransformer';
import { transformMobileRendering } from './mobileRenderingTransformer';

export { transformMobileFriendliness } from './mobileFriendlinessTransformer';
export { transformTapTargets } from './tapTargetsTransformer';
export { transformMobileViewport } from './mobileViewportTransformer';
export { transformMobileRendering } from './mobileRenderingTransformer';

/**
 * Transforms the Mobile section data from WooRank API response
 * @param {Object} apiData - The full API response data
 * @returns {Object} - Transformed mobile section data for React components
 */
export const transformMobileSection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};

  const mobileFriendliness = transformMobileFriendliness(criteria?.mobile_friendliness);
  const tapTargets = transformTapTargets(criteria?.mobile_taptargets);
  const mobileViewport = transformMobileViewport(criteria?.mobile_viewport);
  const mobileRendering = transformMobileRendering(criteria?.mobile_rendering);

  const allResults = [mobileFriendliness, tapTargets, mobileViewport, mobileRendering];
  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    mobileFriendliness,
    tapTargets,
    mobileViewport,
    mobileRendering,
  };
};

export default transformMobileSection;

